export default "__VITE_ASSET__Cxsa$oP8__"